import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'duplicateStream';
export const useDuplicateStreamTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Дублировать',
    on_success: 'Источник создан',
    on_error: 'Не удалось создать источник',
    duplicate_stream_form: {
      title: 'Дублирование источника',
      name: 'Название',
      type: 'Тип',
      reference: 'Полный путь',
      group: 'Группа',
      analytics: 'Видеоаналитика',
      on_cancel: 'Отмена',
      on_submit: 'Создать',
      stream_type_stream: 'Поток',
      stream_type_videofile: 'Видеофайл',
      validation: {
        required: 'Заполните обязательные поля',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Duplicate',
    on_success: 'Source created',
    on_error: 'Failed to create source',
    duplicate_stream_form: {
      title: 'Duplicate source',
      name: 'Name',
      type: 'Type',
      reference: 'Full path',
      group: 'Group',
      analytics: 'Video analytics',
      on_cancel: 'Cancel',
      on_submit: 'Create',
      stream_type_stream: 'Stream',
      stream_type_videofile: 'Video file',
      validation: {
        required: 'Fill in the required fields',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Duplicar',
    on_success: 'Fuente creada',
    on_error: 'No se pudo crear la fuente',
    duplicate_stream_form: {
      title: 'Duplicar fuente',
      name: 'Nombre',
      type: 'Tipo',
      reference: 'Ruta completa',
      group: 'Grupo',
      analytics: 'Videoanalítica',
      on_cancel: 'Cancelar',
      on_submit: 'Crear',
      stream_type_stream: 'Flujo',
      stream_type_videofile: 'Archivo de video',
      validation: {
        required: 'Complete los campos obligatorios',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Duplicar',
    on_success: 'Fonte criada',
    on_error: 'Falha ao criar fonte',
    duplicate_stream_form: {
      title: 'Duplicar fonte',
      name: 'Nome',
      type: 'Tipo',
      reference: 'Caminho completo',
      group: 'Grupo',
      analytics: 'Videoanalítica',
      on_cancel: 'Cancelar',
      on_submit: 'Criar',
      stream_type_stream: 'Fluxo',
      stream_type_videofile: 'Arquivo de vídeo',
      validation: {
        required: 'Preencha os campos obrigatórios',
      },
    },
  },
}) : {}) as Record<string, unknown>;
